module.exports = function(service) {
	'use strict'
	service.factory('checkArray', checkArray);
	checkArray.$inject = [];
	function checkArray() {
	   return {
		   	contains : function(needle) {
			    // Per spec, the way to identify NaN is that it is not equal to itself
			    var findNaN = needle !== needle;
			    var indexOf;

			    if(!findNaN && typeof Array.prototype.indexOf === 'function') {
			        indexOf = Array.prototype.indexOf;
			    } else {
			        indexOf = function(needle) {
			            var i = -1, index = -1;

			            for(i = 0; i < this.length; i++) {
			                var item = this[i];

			                if((findNaN && item !== item) || item === needle) {
			                    index = i;
			                    break;
			                }
			            }

			            return index;
			        };
			    }
			    return indexOf.call(this, needle) > -1;
			},
			removeDuplicate : function(arr) {
				var newArray = arr.filter( function( item, index, inputArray ) {
			           return inputArray.indexOf(item) == index;
			    });
			    return newArray
			},
			removeObjArryDuplicate: function(arr) {
				var newArry = arr.filter(function(item, index, inputArray){
					 return index === inputArray.findIndex(function(element) {
						return element._id == item._id
					})
					
				})
				return newArry
			},
			sortArrayByIdPredefined: function(arr1,arr2) {
				var sortInsert = function (acc, cur) {
					var toIdx = arr2.indexOf(cur._id.toString());
					if(toIdx>=0) {
						acc[toIdx] = cur;
					}
					return acc;
				};
			   	return arr1.reduce(sortInsert, []).filter(function(el){return el!=null})
			},
			reconstructArrayByAncestors: function(flatArray) {
				flatArray = angular.copy(flatArray)
				var roots = [];
				flatArray.forEach(function(obj) {
					if (obj.ancestors && obj.ancestors.length > 0) {
						var parent = obj.ancestors.reduce(function(acc, ancestorId) {
							return acc.children.find(function(child){ return child.objId === ancestorId}) || acc
						}, { children: roots });
					
						if (!parent.children) {
							parent.children = [];
						}
					
						parent.children.push(obj);
					} else {
						roots.push(obj);
					}
				});
				
				return roots;
			}
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/checkArrayService.js
// module id = 587
// module chunks = 0